import { Key } from 'react';

/** react-table props include `key`; React 19 rejects spreading it onto JSX. */
export function omitKeyFromTableProps<T extends { key?: Key }>(
  props?: T | null
): { key: Key | undefined; tableProps: Omit<T, 'key'> } {
  if (props == null) {
    return { key: undefined, tableProps: {} as Omit<T, 'key'> };
  }

  const { key, ...tableProps } = props;
  return { key, tableProps };
}
